import React from 'react';
export const GrowingPlant = () => (
  <svg width="201px" height="155px" viewBox="0 0 201 155" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-790.000000, -1228.000000)">
        <g transform="translate(790.000000, 1228.000000)">
          <path
            d="M148.569827,153.962975 L52.4303682,153.962975 L0.508570047,101.982238 C-0.169523349,101.303381 -0.169523349,100.192603 0.508570047,99.5137463 L99.2670336,0.643177856 C99.9459986,-0.0348067142 101.054655,-0.0348067142 101.732749,0.643177856 L200.492084,99.5137463 C201.169305,100.192603 201.169305,101.303381 200.492084,101.982238 L148.569827,153.962975 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <path
            d="M68,154.223477 C68,154.223477 68,149.576704 77.685,149.584641 C77.685,149.584641 79.759,145.194902 88.297,144.939089 C96.834,144.683885 104.319,149.369122 104.319,149.369122 C104.319,149.369122 112.794,146.728563 117.286,151.992586 C117.286,151.992586 124.50164,151.992586 127.104661,154.223477"
            stroke="#DDE5E8"
            fill="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(118.000000, 9.000000)">
            <g transform="translate(0.000000, 7.000000)">
              <path
                d="M48.8404,11.3754 C46.4574,9.0784 43.3404,9.5924 43.3404,9.5924 C43.3404,9.5924 44.6244,3.9134 36.1914,1.3294 C27.7584,-1.2536 24.0924,4.1994 24.0924,4.1994 C19.5094,0.7564 16.0264,4.7734 14.3774,7.3564 C12.7274,9.9394 11.4444,12.5224 6.1274,13.0974 C0.8114,13.6714 0.2614,18.5504 0.2614,18.5504 L57.4704,18.5504"
                fill="#FFFFFF"
              />
              <path
                d="M48.8404,11.3754 C46.4574,9.0784 43.3404,9.5924 43.3404,9.5924 C43.3404,9.5924 44.6244,3.9134 36.1914,1.3294 C27.7584,-1.2536 24.0924,4.1994 24.0924,4.1994 C19.5094,0.7564 16.0264,4.7734 14.3774,7.3564 C12.7274,9.9394 11.4444,12.5224 6.1274,13.0974 C0.8114,13.6714 0.2614,18.5504 0.2614,18.5504 L57.4704,18.5504"
                stroke="#DCE4E7"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <path
              d="M54,15.717 C55.515,13.475 58.08,12 60.99,12 C65.645,12 69.419,15.775 69.419,20.43 C69.419,25.085 65.645,28.86 60.99,28.86 C59.244,28.86 57.622,28.328 56.277,27.42"
              stroke="#F5C400"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M50,13.127 C52.365,10.012 56.108,8 60.32,8 C67.472,8 73.269,13.797 73.269,20.948 C73.269,28.1 67.472,33.897 60.32,33.897 C56.388,33.897 52.864,32.144 50.49,29.376"
              stroke="#F5C400"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M61,0 L61,4.738"
              stroke="#F5C400"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M61,37 L61,41.738"
              stroke="#F5C400"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M77,21 L81.623,21"
              stroke="#F5C400"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M46,6 L49.351,9.351"
              stroke="#F5C400"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M72,32 L75.351,35.351"
              stroke="#F5C400"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M72,9.269 L75.269,6"
              stroke="#F5C400"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M45,35.27 L48.269,32"
              stroke="#F5C400"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M61.9657974,57.0653468 L61.9657974,59.3888829 M61.9657974,64.0362582 L61.9657974,66.3597943 M66.6081459,61.7130249 L64.2862152,61.7130249 M59.6450771,61.7130249 L57.324155,61.7130249"
            stroke="#0B9CE5"
            strokeLinecap="round"
          />
          <path
            d="M158.40591,105.016641 L158.40591,107.340177 M158.40591,111.986543 L158.40591,114.311089 M163.048258,109.663208 L160.726327,109.663208 M156.085189,109.663208 L153.764267,109.663208"
            stroke="#D62793"
            strokeLinecap="round"
          />
          <path
            d="M44.6904481,86.9457703 C44.6904481,87.9192118 43.9016775,88.7088708 42.9283225,88.7088708 C41.9559762,88.7088708 41.1672056,87.9192118 41.1672056,86.9457703 C41.1672056,85.971319 41.9559762,85.1826699 42.9283225,85.1826699 C43.9016775,85.1826699 44.6904481,85.971319 44.6904481,86.9457703"
            fill="#F5C400"
            fillRule="nonzero"
          />
          <path
            d="M143.764469,82.2078072 C143.764469,83.1812487 142.975698,83.9709076 142.002343,83.9709076 C141.029997,83.9709076 140.241226,83.1812487 140.241226,82.2078072 C140.241226,81.2333559 141.029997,80.443697 142.002343,80.443697 C142.975698,80.443697 143.764469,81.2333559 143.764469,82.2078072"
            fill="#AA81F7"
            fillRule="nonzero"
          />
          <path
            d="M133.97155,154.414234 L173.515644,154.414234 M59.9715502,154.414234 L34.7415498,154.414234 M24.2976022,153.962975 L14.9715502,153.962975"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g transform="translate(155.000000, 78.000000)">
            <path
              d="M44.2032,11.1674 L0.3782,11.2164 C0.3782,11.2164 0.3852,9.3934 3.3842,9.1004 C3.3842,9.1004 4.7782,6.3704 9.6222,6.0844 C9.6222,6.0844 11.0232,1.2274 16.7902,0.9444 C22.5572,0.6614 27.6132,5.8454 27.6132,5.8454 C27.6132,5.8454 32.9832,3.5474 36.3722,7.3964 C36.3722,7.3964 40.1762,7.6234 42.4992,9.0434"
              fill="#FFFFFF"
            />
            <path
              d="M44.2032,11.1674 L0.3782,11.2164 C0.3782,11.2164 0.3852,9.3934 3.3842,9.1004 C3.3842,9.1004 4.7782,6.3704 9.6222,6.0844 C9.6222,6.0844 11.0232,1.2274 16.7902,0.9444 C22.5572,0.6614 27.6132,5.8454 27.6132,5.8454 C27.6132,5.8454 32.9832,3.5474 36.3722,7.3964 C36.3722,7.3964 40.1762,7.6234 42.4992,9.0434"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(12.000000, 34.000000)">
            <path
              d="M43,11.9433147 L0,12 C0,12 0.00637013444,9.87224682 2.94937225,9.52967034 C2.94937225,9.52967034 4.31656235,6.3454343 9.07027517,6.01025156 C9.07027517,6.01025156 10.4446317,0.342541441 16.1029036,0.0131093848 C21.7619718,-0.317965724 26.722714,5.73175414 26.722714,5.73175414 C26.722714,5.73175414 31.9908152,3.05029221 35.3160253,7.54321968 C35.3160253,7.54321968 39.0489241,7.80692963 41.3278397,9.46476976"
              fill="#FFFFFF"
            />
            <path
              d="M43,11.9433147 L0,12 C0,12 0.00637013444,9.87224682 2.94937225,9.52967034 C2.94937225,9.52967034 4.31656235,6.3454343 9.07027517,6.01025156 C9.07027517,6.01025156 10.4446317,0.342541441 16.1029036,0.0131093848 C21.7619718,-0.317965724 26.722714,5.73175414 26.722714,5.73175414 C26.722714,5.73175414 31.9908152,3.05029221 35.3160253,7.54321968 C35.3160253,7.54321968 39.0489241,7.80692963 41.3278397,9.46476976"
              stroke="#DCE4E7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(67.927825, 75.000000)" strokeLinecap="round">
            <g
              transform="translate(26.794118, 0.000000)"
              stroke="#CCD82B"
              strokeLinejoin="round"
              strokeWidth="2"
            >
              <path d="M0,16.6539566 C0,19.0313931 2.29363701,20.9577881 5.12353762,20.9577881 C7.95343823,20.9577881 10.2470752,19.0313931 10.2470752,16.6539566 C10.2470752,14.2782416 7.95343823,12.3501251 5.12353762,12.3501251 C2.29363701,12.3501251 0,10.4237301 0,8.04629363 C0,5.67057866 2.29363701,3.74246215 5.12353762,3.74246215 C7.95343823,3.74246215 10.2470752,5.67057866 10.2470752,8.04629363" />
              <path d="M4.0256367,-2.48689958e-14 L4.0256367,2.79781099" />
              <path d="M4.0256367,20.9577881 L4.0256367,23.7555991" />
            </g>
            <path
              d="M11.4247226,30.5642096 C9.52671722,30.1989973 8.49099784,30.182429 6.54692326,30.0387036 C4.2850858,29.8714859 2.05441766,29.8235294 0,29.8235294 C0,37.4907779 0.667461366,47.6053848 5.704798,52.6427214 C9.9833965,56.9213199 19.3421176,56.1197958 22.819192,52.6427214 C25.6509217,49.8109917 26.7080994,43.0782743 24.6918979,38.3655564 C24.2324103,37.2915389 23.6132994,36.3224349 22.819192,35.5283274 C21.1566848,33.8658202 18.9408284,32.679299 16.4424337,31.8356654"
              stroke="#575825"
              strokeWidth="1.3"
              fill="#5EDAB0"
              strokeLinejoin="round"
            />
            <path
              d="M55.9042534,56.3696806 C55.6156416,56.8429108 55.3055993,57.2938121 54.9725834,57.7192481 C54.6683205,58.1079512 54.3448798,58.4753965 54.0010844,58.819192 C49.7224859,63.0977905 40.3637647,62.2962664 36.8866904,58.819192 C33.409616,55.3421176 32.6080919,45.9833965 36.8866904,41.704798 C41.924027,36.6674614 52.0386338,36 59.7058824,36 C59.7058824,40.3610727 59.489942,45.5139266 58.376749,50.0738911"
              stroke="#575825"
              strokeWidth="1.3"
              fill="#5EDAB0"
              strokeLinejoin="round"
            />
            <path
              d="M49.4117647,47.7810458 C46.0251584,49.3559314 29.4570136,43.2097141 29.4570136,71 C29.4570136,36.4393873 14.3712217,44.1604902 12.3529412,42.1764706"
              stroke="#575825"
              strokeWidth="1.3"
              strokeLinejoin="round"
            />
            <path
              d="M57.6470588,41.1470588 C57.6470588,41.1470588 56.3487597,63.6762926 43.2352941,59.0505018"
              stroke="#FDFDFD"
              strokeWidth="2"
            />
            <path
              d="M3.08823529,32.9117647 C3.45606354,41.309028 4.67854192,46.556954 6.75567044,48.6555429 C9.87136323,51.8034262 13.201336,51.8034262 17.5,50.9737513"
              stroke="#FDFDFD"
              strokeWidth="2.5"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
